import { QueryParameters as BrandPageQueryParameters } from "@faire/web-api/routes/brand/brandToken";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { useEffect, useRef } from "react";

import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { setTimeoutIfPossible } from "@faire/retailer/lib/async-functions/setTimeoutIfPossible";
import {
  popSignUp,
  SignUpElement,
  SignUpType,
} from "@faire/retailer/lib/popSignUp";

export function useFaireDirectAutoSignUp() {
  const { isFaireDirectActiveInLoggedOut } = useFaireDirectBrand();
  const fdAutoSignUpTimeoutId = useRef<number | undefined>();
  const { signUp } = useQueryParams(BrandPageQueryParameters.parse);

  useEffect(() => {
    if (isFaireDirectActiveInLoggedOut) {
      fdAutoSignUpTimeoutId.current = setTimeoutIfPossible(
        () =>
          popSignUp(SignUpType.FAIRE_DIRECT, () => null, {
            element: SignUpElement.AUTO_POPUP,
            sourceId: "logged_out_brand_page_fd_auto_signup",
          }),
        5000
      );
    }

    return () => {
      if (fdAutoSignUpTimeoutId.current) {
        clearTimeout(fdAutoSignUpTimeoutId.current);
      }
    };
  }, [isFaireDirectActiveInLoggedOut]);

  useEffect(() => {
    if (signUp) {
      clearTimeout(fdAutoSignUpTimeoutId.current);
    }
  }, [signUp]);
}
